export default {
  FETCH_LAUNCHED_FORM_BEGIN: 'FETCH_LAUNCHED_FORM_BEGIN',
  FETCH_LAUNCHED_FORM_SUCCESS: 'FETCH_LAUNCHED_FORM_SUCCESS',
  FETCH_LAUNCHED_FORM_FAILURE: 'FETCH_LAUNCHED_FORM_FAILURE',
  SAVE_DRAFT_LAUNCHED_FORM_BEGIN: 'SAVE_DRAFT_LAUNCHED_FORM_BEGIN',
  SAVE_DRAFT_LAUNCHED_FORM_SUCCESS: 'SAVE_DRAFT_LAUNCHED_FORM_SUCCESS',
  SAVE_DRAFT_LAUNCHED_FORM_FAILURE: 'SAVE_DRAFT_LAUNCHED_FORM_FAILURE',
  COMPLETE_LAUNCHED_FORM_BEGIN: 'COMPLETE_LAUNCHED_FORM_BEGIN',
  COMPLETE_LAUNCHED_FORM_SUCCESS: 'COMPLETE_LAUNCHED_FORM_SUCCESS',
  COMPLETE_LAUNCHED_FORM_FAILURE: 'COMPLETE_LAUNCHED_FORM_FAILURE',
  COMPLETE_LAUNCHED_FORM_FAILURE_NOT_AVAILABLE: 'COMPLETE_LAUNCHED_FORM_FAILURE_NOT_AVAILABLE',
  UPDATE_LAUNCHED_FORM_UNANSWERED_COUNT: 'UPDATE_LAUNCHED_FORM_UNANSWERED_COUNT',
  RESET_LAUNCHED_FORM_STATE: 'RESET_LAUNCHED_FORM_STATE',
  SET_LAUNCHED_FORM_MODIFIED: 'SET_LAUNCHED_FORM_MODIFIED',
  LAUNCHED_FORM_CANCEL_REQUESTED: 'LAUNCHED_FORM_CANCEL_REQUESTED',
  LAUNCHED_FORM_CANCEL_CANCELLED: 'LAUNCHED_FORM_CANCEL_CANCELLED',
  DECLINE_LAUNCHED_FORM_BEGIN: 'DECLINE_LAUNCHED_FORM_BEGIN',
  DECLINE_LAUNCHED_FORM_SUCCESS: 'DECLINE_LAUNCHED_FORM_SUCCESS',
  DECLINE_LAUNCHED_FORM_FAILURE: 'DECLINE_LAUNCHED_FORM_FAILURE',
  SET_LAUNCHED_FORM_ACTION_TAKEN_DISPLAY: 'SET_LAUNCHED_FORM_ACTION_TAKEN_DISPLAY',
  SET_SESSION_TIMEOUT_EXPIRING: 'SET_SESSION_TIMEOUT_EXPIRING',
  CLEAR_SESSION_TIMEOUT_EXPIRING: 'CLEAR_SESSION_TIMEOUT_EXPIRING',
};